import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import useFolders from '../../../folders/useFolders';
import AdTableRow from './AdTableRow';

interface IAdsTableProps {
  columnTitles: string[];
  ads: Ads;
  needCheck: boolean;
  display?: number;
  minIndexTab: number;
}

const useStyles = makeStyles({
  table: {
    marginBottom: '20px',
  },
  body: {
    padding: 0,
    textAlign: 'center',
  },
});

function AdsTable({
  columnTitles,
  ads,
  needCheck,
  display,
  minIndexTab,
}: IAdsTableProps) {
  const classes = useStyles();
  const { folders } = useFolders({});

  const displayedAds = display
    ? ads.filter((elt, index) =>
        minIndexTab ? index >= minIndexTab && index < minIndexTab + display : true,
      )
    : ads;

  const titles = needCheck ? ['', ...columnTitles] : columnTitles;

  return (
    <TableContainer className={classes.table}>
      <Table>
        <TableHead>
          <TableRow>
            {titles.map((c) => (
              <TableCell key={c} className={classes.body}>
                {c}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {displayedAds.map((r) => (
            <AdTableRow
              key={r.idIri}
              data={r}
              folders={folders.result}
              needCheck={needCheck}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default AdsTable;
